import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, assertUnreachable } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";



type Entity = models.StatusRastreoDTO;
export interface Props {
    value: Entity[];
}

export function statusToString(x: models.StatusGuia): string {
    switch (x) {
        case models.StatusGuia.ContenidoPendiente:
            return "La guía aún no ha sido entregada a la sucursal de origen";
        case models.StatusGuia.EnCamionEAD:
            return "Carga en camión de entrega a domicilio";
        case models.StatusGuia.EnEmbarque:
            return "Carga en móvil de ruta";
        case models.StatusGuia.EnSucursalDestino:
            return "En sucursal destino";
        case models.StatusGuia.EnSucursalOrigen:
            return "En sucursal origen";
        case models.StatusGuia.EnSucursalTrasbordo:
            return "En sucursal de trasbordo";
        case models.StatusGuia.EntregadaDomicilio:
            return "Entregada a domicilio";
        case models.StatusGuia.EntregadaZonaExtendida:
            return "Entregada a ze";
        case models.StatusGuia.EntregadaOcurre:
            return "Entregada a ocurre";
        case models.StatusGuia.EnViaje:
            return "En viaje de ruta";
        case models.StatusGuia.EnViajeEAD:
            return "En viaje de entrega a domicilio";
        case models.StatusGuia.EnViajeZE:
            return "En viaje de entrega a ZE";
        case models.StatusGuia.EnVehiculoZE:
            return "En vehículo de zona extendida";
        case models.StatusGuia.EnViajeEADIncompleta:
            return "No se encontró cliente en entrega a domiciio";
        case models.StatusGuia.EnViajeZEIncompleta:
            return "No se encontró cliente en entrega a ze";
        case models.StatusGuia.EnViajeEADRechazada:
            return "Entrega a domicilio rechazada por cliente";
        case models.StatusGuia.EnViajeZEIncompleta:
            return "Entrega a ze incompleta";
        case models.StatusGuia.EntregaZERechazada:
            return "Entrega a ze rechazada por cliente";
        case models.StatusGuia.RecoleccionPendiente:
            return "Recolección a domicilio pendiente";
        case models.StatusGuia.Cancelada:
            return "Cancelada";

        case models.StatusGuia.Invalido:
            return "Invalido";
        default:
            return assertUnreachable(x);
    }
}

/**Obtiene las columnas del grid */
function columnas(deps: {}): kea.Grid2Column<Entity>[] {
    return [
        { title: "Fecha", cell: x => ({ data: kea.toDate(x.Fecha) }) },
        { title: "Status", cell: x => ({ data: statusToString(x.Status) }) },
        { title: "Ubicación", cell: x => ({ data: x.NombreSucursal }) }
    ];
}

/**
* Listado de StatusRastreoDTO
*/
class StatusRastreoDTOListNoRx extends React.PureComponent<Props> {
    private modals = kea.createModalManager();

    render() {
        const cols = columnas(this);
        return (
            <div>
                <kea.Title size="h3" titulo="Historia de la guía" />
                <kea.Grid2 items={this.props.value} columnas={cols} hideBusqueda />
            </div>
        );
    }
}
export const StatusRastreoDTOList = kea.mapProps(componentToRx(StatusRastreoDTOListNoRx), x => ({ ...x, value: x.value || [] }));


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/rastreo/listastatus.tsx